import { Box } from '@mui/material';
import {
  DataGridPro as MuiDataGridPro,
  type DataGridProProps,
} from '@mui/x-data-grid-pro';

const tableContainerStyles = {
  width: '100%',
  paddingTop: '8px',
};

const tableStyles = {
  fontFamily: 'Source Sans Pro',
  border: 'none',
  '& .MuiDataGrid-cell': {
    fontFamily: 'Source Sans Pro',
    borderBottom: '1px solid #EBEBEB',
    borderRight: 'none',
    borderLeft: 'none',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20.02px',
    letterSpacing: '0.17px',
    padding: 0,
  },
  '& .MuiDataGrid-columnHeaders': {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    borderBottom: '1px solid #D3D3D3',
    borderTop: 'none',
    borderRight: 'none',
    borderLeft: 'none',
    outline: 'none',
  },
  '& .MuiDataGrid-columnHeader': {
    outline: 'none !important',
    '&:focus': {
      outline: 'none !important',
    },
    '&:focus-within': {
      outline: 'none !important',
    },
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: '0.17px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    color: 'rgba(1, 16, 18, 0.90)',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: '#F5F5F6',
  },
  '& .MuiDataGrid-main': {
    borderRadius: 0,
  },
  '& .MuiDataGrid-footerContainer': {
    fontFamily: 'Source Sans Pro',
    fontSize: '12px',
    '& .MuiTablePagination-root': {
      fontSize: '12px',
      color: 'rgba(1, 16, 18, 0.90)',
      '& .MuiTablePagination-displayedRows': {
        color: 'rgba(1, 16, 18, 0.9)',
      },
    },
    '& .MuiTablePagination-selectLabel': {
      fontFamily: 'Source Sans Pro',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '19.92px',
      letterSpacing: '0.4px',
      textAlign: 'left',
      textUnderlinePosition: 'from-font',
      textDecorationSkipInk: 'none',
      color: 'rgba(1, 16, 18, 0.60)',
      margin: 0,
      padding: 0,
    },
    '& .MuiTablePagination-displayedRows': {
      fontFamily: 'Source Sans Pro',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '19.92px',
      letterSpacing: '0.4px',
      textAlign: 'left',
      textUnderlinePosition: 'from-font',
      textDecorationSkipInk: 'none',
      color: 'rgba(1, 16, 18, 0.90)',
    },
    '& .MuiTablePagination-select': {
      fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, sans-serif',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '19px',
      letterSpacing: '0.4px',
      textAlign: 'left',
      textUnderlinePosition: 'from-font',
      textDecorationSkipInk: 'none',
      color: 'rgba(1, 16, 18, 0.90)',
    },
    '& .MuiTablePagination-menuItem': {
      fontSize: '172px',
    },
    '& .MuiTablePagination-actions': {
      '& .MuiIconButton-root': {
        color: '#7E8586',
        '&.Mui-disabled': {
          color: '#7E8586',
        },
      },
    },
  },
};

const DataGridPro = (props: DataGridProProps) => {
  return (
    <Box sx={tableContainerStyles}>
      <MuiDataGridPro {...props} sx={tableStyles} />
    </Box>
  );
};

export { DataGridPro };
export type { DataGridProProps };
